import { createApp } from "vue";
import { reactive, h } from "#imports";
import Tooltip from "./TooltipText.vue";
const TooltipDirective = {
  mounted(reference, binding) {
    if (!binding.value) return;
    const props = reactive({
      reference,
      text: binding.value,
      placement: binding.arg
    });
    const instance = createApp({
      render: () => h(Tooltip, props)
    }).mount(document.createElement("div"));
    document.body.appendChild(instance.$el);
    reference._tooltip = { instance, props };
  },
  updated(reference, binding) {
    if (!reference._tooltip) return;
    reference._tooltip.props.text = binding.value;
  },
  unmounted(reference) {
    if (!reference._tooltip) return;
    const { instance } = reference._tooltip;
    document.body.removeChild(instance.$el);
  }
};
export default TooltipDirective;
